import { render } from "./SchemaMarkupTextField.vue?vue&type=template&id=4b675c52"
import script from "./SchemaMarkupTextField.vue?vue&type=script&lang=js"
export * from "./SchemaMarkupTextField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__